import { BeanPrimaryEntity } from '../../bean-primary-entity';
import { BoilersFuel } from './boilers-fuel';

export class Boilers extends BeanPrimaryEntity {

    boilerId: number;
    name: string;
    type: number | null;
    unitId: number;
    manufacturerId: number;
    model: string;
    designFirmId: number;
    constructorId: number;
    startUpDate: Date | null;
    shutDownDate: Date | null;
    saeMetric: string;
    designSteamFlow: number | null;
    designPressure: number | null;
    designTemperature: number | null;
    designH20Consumption: number;
    designBtuConsumption: number | null;
    operatingSteamFlow: number | null;
    operatingPressure: number | null;
    operatingTemperature: number | null;
    operatingH20Consumption: number;
    operatingBtuConsumption: number | null;
    steamUnits: string;
    pressureUnits: string;
    tempUnits: string;
    H20Units: string;
    btuUnits: string;
    startUpResolution: number | null;
    shutDownResolution: number | null;
    boilerStatus: string | null;

    boilersFuel: BoilersFuel[] = [];

    constructor(entity?: any) {
        super(entity);

        this.boilerId = entity?.boilerId ?? null;
        this.name = entity?.name ?? '';
        this.type = entity?.type ?? null;
        this.unitId = entity?.unitId ?? '';
        this.manufacturerId = entity?.manufacturerId ?? '';
        this.model = entity?.model ?? '';
        this.designFirmId = entity?.designFirmId ?? '';
        this.constructorId = entity?.constructorId ?? '';
        this.startUpDate = entity?.startUpDate ?? null;
        this.shutDownDate = entity?.shutDownDate ?? null;
        this.saeMetric = entity?.saeMetric ?? '';
        this.designSteamFlow = entity?.designSteamFlow;
        this.designPressure = entity?.designPressure;
        this.designTemperature = entity?.designTemperature;
        this.designH20Consumption = entity?.designH20Consumption ?? '';
        this.designBtuConsumption = entity?.designBtuConsumption;
        this.operatingSteamFlow = entity?.operatingSteamFlow;
        this.operatingPressure = entity?.operatingPressure;
        this.operatingTemperature = entity?.operatingTemperature;
        this.operatingH20Consumption = entity?.operatingH20Consumption ?? '';
        this.operatingBtuConsumption = entity?.operatingBtuConsumption;
        this.steamUnits = entity?.steamUnits ?? '';
        this.pressureUnits = entity?.pressureUnits ?? '';
        this.tempUnits = entity?.tempUnits ?? '';
        this.H20Units = entity?.H20Units ?? '';
        this.btuUnits = entity?.btuUnits ?? '';
        this.startUpResolution = entity?.startUpResolution ?? null;
        this.shutDownResolution = entity?.shutDownResolution ?? null;
        this.boilerStatus = entity?.boilerStatus ?? null;

        this.boilersFuel = entity?.boilersFuel ?? [];
    }
}